import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from 'react-icons/fa';

const ContactPage = () => {
    return (
        <div className="py-5" style={{ backgroundColor: '#f0efe9' }}>
            <Container>
                <div className="text-center mb-5">
                    <h1 className="display-4" style={{ fontFamily: 'Cinzel, serif' }}>Hubungi Kami</h1>
                    <p className="lead" style={{ fontFamily: 'Poppins, sans-serif' }}>
                        Punya pertanyaan atau ingin menitipkan barang untuk lelang? Jangan ragu untuk menghubungi kami.
                    </p>
                </div>

                {/* Row diubah untuk menumpuk konten secara vertikal */}
                <Row className="justify-content-center">
                    {/* Kolom Info Kontak (sekarang di atas) */}
                    <Col md={10} lg={8} className="mb-5">
                        <h3 style={{ fontFamily: 'Poppins, sans-serif' }}>Informasi Kontak</h3>
                        <p style={{ fontFamily: 'Poppins, sans-serif' }}>
                            Kunjungi kantor kami atau hubungi kami melalui detail di bawah ini. Tim kami siap membantu Anda.
                        </p>
                        <div className="d-flex align-items-start mb-3">
                            <FaMapMarkerAlt size={24} className="me-3 mt-1" style={{color: '#c5a65B'}} />
                            <div>
                                <strong>Alamat:</strong>
                                <p className="mb-0">Jl. Selat Sunda 2 No. 44, Malang, Jawa Timur, Indonesia</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-start mb-3">
                            <FaEnvelope size={24} className="me-3 mt-1" style={{color: '#c5a65B'}} />
                            <div>
                                <strong>Email:</strong>
                                <p className="mb-0">info@syailendra-auction.com</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-start mb-3">
                            <FaPhone size={24} className="me-3 mt-1" style={{color: '#c5a65B'}} />
                            <div>
                                <strong>Telepon:</strong>
                                <p className="mb-0">+62 812 3345 67890</p>
                            </div>
                        </div>
                    </Col>

                    {/* Kolom Formulir Kontak (sekarang di bawah) */}
                    <Col md={10} lg={8}>
                        <h3 style={{ fontFamily: 'Poppins, sans-serif' }}>Kirim Pesan</h3>
                        <Form>
                            <Form.Group className="mb-3" controlId="formGroupName">
                                <Form.Label>Nama</Form.Label>
                                <Form.Control type="text" placeholder="Masukkan nama Anda" />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formGroupEmail">
                                <Form.Label>Alamat Email</Form.Label>
                                <Form.Control type="email" placeholder="Masukkan email Anda" />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formGroupSubject">
                                <Form.Label>Subjek</Form.Label>
                                <Form.Control type="text" placeholder="Subjek pesan" />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formGroupMessage">
                                <Form.Label>Pesan</Form.Label>
                                <Form.Control as="textarea" rows={5} placeholder="Tulis pesan Anda di sini" />
                            </Form.Group>
                            <Button variant="dark" type="submit" className="w-100">
                                Kirim
                            </Button>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default ContactPage;